import PublicLayout from '@/app/layouts/PublicLayout';

import { homeRoutes } from '@/features/public/home/home.routes';
import { aboutRoutes } from '@/features/public/about-us/about.routes';

const featureRoutes = [
  ...homeRoutes,
  ...aboutRoutes,
];

export const publicRoutes = [
  {
    path: '/',
    element: <PublicLayout />,
    children: featureRoutes,
  },
];